import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import { Observable } from 'rxjs/Observable';
import { Base, Modal, ParametroFiltro } from '@app/shared';

@Injectable()
export class ReportFilterDataService {

  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) { }


  /**
   * Metodo que devuelve todoss los filtros por reporte
   *
   * @param {number} id
   * @return {*}  {Observable<ParametroFiltro[]>}
   * @memberof ReportFilterDataService
   */
  getFilters(id: number): Observable<ParametroFiltro[]> {
    return new Observable(obs => {
      this.http.skipErrorHandler().get<ParametroFiltro[]>(this.api.get('filterReportParameter', [id])).subscribe(
        data => {
          obs.next(data);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  getModals(): Observable<Modal[]> {
    return new Observable(obs => {
      this.http.skipErrorHandler().get<Modal[]>(this.api.get('adminModals')).subscribe(
        data => {
          obs.next(data);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }
  getTypeField(): Observable<Base[]> {
    return new Observable(obs => {
      this.http.skipErrorHandler().get<Base[]>(this.api.get('typeSearchFields')).subscribe(
        data => {
          obs.next(data);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }


  /**
   * Metodo que permite agregar un filtro.
   *
   * @param {number} id
   * @param {ParametroFiltro} filter
   * @return {*}  {Promise<boolean>}
   * @memberof BulletinsDataService
   */
  cretateFilter(filter: ParametroFiltro): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.post<boolean>(this.api.get('filterReportParameter'), filter).subscribe(
        _resp => {
          this.toastr.success('Operación exitosa', 'Filtro creado correctamente');
          resolve(true);
        },
        err => {
          if (err.status === 400) {
            if (err.error) {
              this.toastr.warning('Error al ejecutar operacion', err.error);
            } else if (err.error.detail) {
              this.toastr.warning('Error al ejecutar operacion', err.error.detail);
            }
          } else if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          reject(err);
        }
      );
    });
  }



  /**
   * Metodo que permite modificar un filtro
   *
   * @param {number} id
   * @param {Boletines} bulletin
   * @return {*}  {Promise<boolean>}
   * @memberof BulletinsDataService
   */
  updateFilter(id: number, filter: ParametroFiltro): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.put<boolean>(this.api.get('filterReportParameter', [id]), filter).subscribe(
        _resp => {
          this.toastr.success('Operación exitosa', 'Filtro modificado correctamente');
          resolve(true);
        },
        err => {
          if (err.status === 400) {
            this.toastr.warning('Error al ejecutar operacion', err.error.detail);
          } else if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          reject(err);
        }
      );
    });
  }


  /**
   * Metodo que permite eliminar un un filtro
   *
   * @param {number} id
   * @return {*}  {Promise<boolean>}
   * @memberof BulletinsDataService
   */
  deleteFilter(id: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler().delete<boolean>(this.api.get('filterReportParameter', [id])).subscribe(
        resp => {
          this.toastr.success('Operación exitosa', 'Filtro eliminado correctamente');
          resolve(true);
        },
        err => {
          if (err.status === 400) {
            if (err.error) {
              this.toastr.warning('Error al ejecutar operacion', err.error);
            } else if (err.error.detail) {
              this.toastr.warning('Error al ejecutar operacion', err.error.detail);
            }
          } else if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          reject(err);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/management-reports/reports/report-filter/shared/report-filter.data.service.ts